import React from 'react';
import './TripDetailHero.css';

function TripDetailHero({ tour }) {
  return (
    <section 
      className="trip-detail-hero"
      style={{
        backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url(${tour.image})`
      }}
    >
      <div className="trip-detail-hero-content">
        <div className="trip-detail-category">{tour.category || 'Silver'}</div>
        <h1 className="trip-detail-title">{tour.name}</h1>
        <div className="trip-detail-meta">
          <div className="trip-detail-meta-item">
            <span className="trip-detail-meta-icon">⏱</span>
            <span>{tour.duration}</span>
          </div>
          <div className="trip-detail-meta-item">
            <span className="trip-detail-meta-icon">⭐</span>
            <span>{tour.rating} Rating</span>
          </div>
          <div className="trip-detail-meta-item">
            <span className="trip-detail-meta-icon">💰</span>
            <span>From ${(parseInt(String(tour.price).replace(/,/g, '')) || 0).toLocaleString()}</span>
          </div>
        </div>
      </div>
    </section>
  );
}

export default TripDetailHero;

